import { Link } from "wouter";
import SEO from "@/components/SEO";
import { Home, MapPin, BookOpen } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page Not Found"
        description="The page you are looking for could not be found. Explore our Turkey travel guides, destinations, and blog for your next adventure."
      />

      <div className="min-h-[60vh] w-full flex items-center justify-center bg-gray-50 py-16">
        <div className="text-center max-w-xl mx-4">
          <h1 className="text-6xl font-bold text-[#E30A17] mb-4">404</h1>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            Sorry, we couldn't find the page you're looking for. It may have been moved, renamed, or no longer exists. Let us help you find what you need.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#E30A17] text-white rounded-lg hover:bg-red-700 transition"
            >
              <Home className="h-4 w-4" />
              Go Home
            </Link>
            <Link
              href="/destinations"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
            >
              <MapPin className="h-4 w-4" />
              Destinations
            </Link>
            <Link
              href="/blog"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
            >
              <BookOpen className="h-4 w-4" />
              Blog
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
